import { BatchAnswerDatasetsResource as e } from "./datasets/BatchAnswerDatasets.resource.js";
import { EvaluationResource as t } from "./evaluations/BatchAnswerEvaluations.resource.js";
import { EvaluationRunResource as n } from "./runs/BatchAnswerEvaluationRuns.resource.js";
import { Resource as r } from "@coveo/platform-client";
//#region src/resources/batch-answer/BatchAnswerResource.ts
var i = class extends r {
	constructor(r, i) {
		super(r, i), this.dataset = new e(r, i), this.evaluation = new t(r, i), this.run = new n(r, i);
	}
};
//#endregion
export { i as BatchAnswerResource };

//# sourceMappingURL=BatchAnswerResource.js.map